import { SalaryElement } from '@pflegia/types/api/job-position/salary-element';

const FULL_TIME_HOURS = 40;
// TODO-GREEN-DR: Would be good to know more about the decision behind this number
const HOURS_MULTIPLIER = 173;

const getSurgeIncomeWithCalculatedValues = ({
  surgeIncomeElements,
  fullTimeHours,
  threeYearExperience,
  shiftDurationHours,
}: {
  surgeIncomeElements: SalaryElement[];
  fullTimeHours: number;
  threeYearExperience: number;
  shiftDurationHours: number;
}): SalaryElement[] => {
  const adjustedHours = (fullTimeHours / FULL_TIME_HOURS) * HOURS_MULTIPLIER;
  const hourlyWage = threeYearExperience / adjustedHours;

  return surgeIncomeElements
    .filter(({ percent }) => percent)
    .map(surgeIncome => ({
      ...surgeIncome,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion, no-magic-numbers
      value: hourlyWage * (surgeIncome.percent! / 100) * surgeIncome.daysPerMonth! * shiftDurationHours,
    }));
};

export default getSurgeIncomeWithCalculatedValues;
